import React from 'react';
import './ForgotPassword.css';
//import 'bootstrap-icons/font/bootstrap-icons.css';
export default function ForgotPassword(){
    return(<div className="Forgotpassword">
        <div className="container-fluid1" >
        <div className="row justify-content-center align-content-center" style={{height:"100vh"}}>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-7 col-sm-10 col-12 border bg-white p-5 shadow rounded-3  h-auto">
                <div className="text-center">
                    <img src="images/logo.png" className="icueLogo" style={{marginLeft:"1rem"}} />
                    <h3 className="text-capitalize pt-3" style={{fontFamily:"ErasDemiITC"}}>Forgot password</h3>
                    <p className="text-muted">Enter your email to get reset password link</p>
                </div>
                <form id="icueSuperAdminForm" className="">
                    <div className="row">
                        <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-8 col-sm-10 col-10 mx-auto">
                            <div className="row">
                                <div className="col-12 pt-2">
                                    <div className="form-group pb-2">
                                        <input type="email" className="form-control icueResetPassEmail text-capitalize" name="icueResetPassEmail" id="icueResetPassEmail" placeholder="enter email" />
                                    </div>
                                </div>

                                <div className="col-12 py-3">
                                    <div className="d-grid gap-2">
                                        <button type="button" className="btn btn-primary  " style={{fontFamily:"Calibri"}} >
                                            Send
                                            {/* <i className="bi bi-arrow-right-short" ></i> */}
                                        </button>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        
        </div>
    </div>
    </div>)
}